// ============================================================================
// HOOPS FOR THOUGHT: FREE AGENT POOL
// Tracks available free agents — unsigned players, waived players,
// and players whose contracts have expired.
// ============================================================================

import PLAYER_POSITIONS from './playerPositions';
import { getPlayerRating } from './playerRatings';

// ============================================================================
// INITIAL FREE AGENT POOL (Feb 2026 — unsigned / recently waived)
// Sources: Hoops Rumors, Bleacher Report, NBA.com free agent tracker
// ============================================================================
export const INITIAL_FREE_AGENTS = [
  // --- Top 100 NBA Free Agents (2K26 ratings) ---
  { name: 'Malik Beasley', position: 'SG', age: 29, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Ben Simmons', position: 'PG', age: 29, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Malcolm Brogdon', position: 'PG', age: 33, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Spencer Dinwiddie', position: 'PG', age: 33, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Cole Anthony', position: 'PG', age: 25, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jeremiah Robinson-Earl', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Dante Exum', position: 'SG', age: 30, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Torrey Craig', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'DaQuan Jeffries', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Georges Niang', position: 'PF', age: 32, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Brandon Boston Jr.', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Eric Gordon', position: 'SG', age: 37, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Trey Lyles', position: 'PF', age: 30, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Cody Martin', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Shake Milton', position: 'PG', age: 29, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Lonzo Ball', position: 'PG', age: 28, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Chris Paul', position: 'PG', age: 40, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Keon Johnson', position: 'SG', age: 24, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Alec Burks', position: 'SG', age: 35, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Dario Saric', position: 'PF', age: 31, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Bojan Bogdanovic', position: 'SF', age: 37, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Garrison Mathews', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Kenyon Martin Jr.', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Tony Bradley', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Reggie Jackson', position: 'PG', age: 35, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Damion Lee', position: 'SG', age: 33, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Delon Wright', position: 'PG', age: 33, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Bol Bol', position: 'PF', age: 25, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Chris Boucher', position: 'C', age: 33, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jae Crowder', position: 'SF', age: 35, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Richaun Holmes', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Dariq Whitehead', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Johnny Juzang', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Cory Joseph', position: 'PG', age: 34, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jalen McDaniels', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Orlando Robinson', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Ricky Council IV', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Monte Morris', position: 'PG', age: 31, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Daniel Theis', position: 'C', age: 33, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jared Butler', position: 'PG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Malaki Branham', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Lonnie Walker IV', position: 'SG', age: 26, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Elfrid Payton', position: 'PG', age: 31, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Christian Wood', position: 'C', age: 30, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'James Wiseman', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Cam Reddish', position: 'SF', age: 26, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Kessler Edwards', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Chris Duarte', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jaden Springer', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jared Rhoden', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Vlatko Cancar', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Trevelin Queen', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'David Roddy', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Colby Jones', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Patty Mills', position: 'PG', age: 37, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Josh Richardson', position: 'PG', age: 32, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jeff Dowtin', position: 'PG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Mo Bamba', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Terence Davis', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Talen Horton-Tucker', position: 'SF', age: 25, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'P.J. Tucker', position: 'PF', age: 40, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Terry Taylor', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Markelle Fultz', position: 'PG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Lamar Stevens', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Drew  Peterson', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Chuma Okeke', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Alex Reese', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Cole Swider', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Lester Quinones', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'P.J. Dozier', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Kevin Knox II', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Kylor Kelley', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Johnny Davis', position: 'SG', age: 24, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jalen Hood-Schifino', position: 'SG', age: 23, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Maxwell Lewis', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Oshae Brissett', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Alex Len', position: 'C', age: 32, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jaylen Nowell', position: 'PG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'JT Thor', position: 'PF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Stanley Umude', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Malachi Flynn', position: 'PG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Kai Jones', position: 'C', age: 24, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Bruno Fernando', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Taj Gibson', position: 'C', age: 40, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Markieff Morris', position: 'PF', age: 36, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Jahlil Okafor', position: 'C', age: 30, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Cody Zeller', position: 'C', age: 33, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Matt Ryan', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Moses Brown', position: 'C', age: 25, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'James Johnson', position: 'PF', age: 38, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Tristan Thompson', position: 'C', age: 35, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Josh Christopher', position: 'SG', age: 24, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Justin Minaya', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Luke Travers', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Reece Beekman', position: 'PG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'David Duke Jr.', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Tyler Smith', position: 'C', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Trentyn Flowers', position: 'SF', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Daishen Nix', position: 'PG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
  { name: 'Mason Jones', position: 'SG', age: 27, lastTeam: 'FA', type: 'UFA', reason: 'unsigned' },
];

// ============================================================================
// WAIVE RULES (CBA-accurate as of 2025-26 season)
// ============================================================================
//
// KEY DATES:
//   Jan 7:  Functional deadline to waive non-guaranteed contracts
//   Jan 10: ALL remaining salaries become fully guaranteed for the season
//   Mar 1:  Players waived after this date can't play in playoffs for new team
//   Mar 4:  Deadline to sign two-way contracts
//
// GUARANTEE RULES (as of Feb 2026 — PAST Jan 10):
//   - Current season (2025-26): ALL salaries are fully guaranteed
//   - Future guaranteed years: Dead money owed in full
//   - Team Option (T) years: Team declines, $0 dead money
//   - Player Option (P) years: Voided when waived, $0 dead money
//     (Per CBA: "If Contract is terminated prior to Player's exercise
//      of the Option, Team is relieved of obligation")
//   - Qualifying Offer (Q) years: Not guaranteed, $0 dead money
//   - Two-way contracts: Guaranteed for remainder after Jan 10 (~$318K)
//
// POST-WAIVE:
//   - Player goes on waivers for 48 hours
//   - If claimed: new team assumes contract
//   - If unclaimed: player becomes UFA, dead salary stays on waiving team
//   - Stretch provision: Spread dead money over (remaining years × 2) + 1
//   - Team can't re-sign stretched player until original contract expires
//   - 15% of salary cap max for total stretched salary per season
// ============================================================================

/**
 * Determine what's guaranteed for each year of a player's contract
 * Returns per-year breakdown of dead money if waived
 *
 * @param {Object} player - player object from salaryData
 * @param {string} seasonPhase - 'regular'|'postDeadline'|'offseason'|'playoffs'
 * @returns {Object} detailed waive analysis
 */
export function analyzeWaive(player, seasonPhase = 'regular') {
  const salaries = [
    { year: '2025-26', amount: player.salary2526 || 0, idx: 0 },
    { year: '2026-27', amount: player.salary2627 || 0, idx: 1 },
    { year: '2027-28', amount: player.salary2728 || 0, idx: 2 },
    { year: '2028-29', amount: player.salary2829 || 0, idx: 3 },
  ];

  // Parse option string: e.g. "T 26-27", "P 27-28", "T 27-28, Q 28-29"
  const optionStr = (player.option || '').trim();
  const optionMap = {}; // idx -> type ('T', 'P', 'Q')

  if (optionStr) {
    const parts = optionStr.split(',').map(s => s.trim());
    for (const part of parts) {
      const type = part.charAt(0).toUpperCase(); // T, P, or Q
      if (['T', 'P', 'Q'].includes(type)) {
        // Match year patterns: "26-27", "2026-27", "2027", etc.
        if (part.match(/26-27|2026/)) optionMap[1] = type;
        if (part.match(/27-28|2027/)) optionMap[2] = type;
        if (part.match(/28-29|2028/)) optionMap[3] = type;
      }
    }
  }

  // Calculate dead money per year
  const deadMoney = [];
  const details = [];
  let canWaiveClean = true; // true if waiving costs nothing

  for (const sal of salaries) {
    if (sal.amount === 0) {
      deadMoney.push(0);
      continue;
    }

    const optType = optionMap[sal.idx];

    if (sal.idx === 0) {
      // CURRENT SEASON: Always guaranteed after Jan 10
      // Past Jan 10 = full salary owed
      deadMoney.push(sal.amount);
      details.push({ year: sal.year, amount: sal.amount, status: 'Guaranteed (past Jan 10)', dead: true });
      canWaiveClean = false;
    } else if (optType === 'T') {
      // TEAM OPTION: Team declines, no dead money
      deadMoney.push(0);
      details.push({ year: sal.year, amount: sal.amount, status: 'Team Option — Declined', dead: false });
    } else if (optType === 'P') {
      // PLAYER OPTION: Voided when waived (CBA protection extinguished)
      deadMoney.push(0);
      details.push({ year: sal.year, amount: sal.amount, status: 'Player Option — Voided', dead: false });
    } else if (optType === 'Q') {
      // QUALIFYING OFFER: Not guaranteed
      deadMoney.push(0);
      details.push({ year: sal.year, amount: sal.amount, status: 'Qualifying Offer — Not Guaranteed', dead: false });
    } else {
      // NO OPTION = Fully guaranteed future year
      deadMoney.push(sal.amount);
      details.push({ year: sal.year, amount: sal.amount, status: 'Fully Guaranteed', dead: true });
      canWaiveClean = false;
    }
  }

  const totalDead = deadMoney.reduce((s, v) => s + v, 0);
  const deadYears = deadMoney.filter(v => v > 0).length;

  // Stretch calculation
  let stretch = null;
  if (deadYears > 0 && totalDead >= 250000) {
    const stretchYears = (deadYears * 2) + 1;
    const annualHit = Math.ceil(totalDead / stretchYears);
    const schedule = [];
    let rem = totalDead;
    for (let i = 0; i < stretchYears; i++) {
      const hit = Math.min(annualHit, rem);
      schedule.push(hit);
      rem -= hit;
    }
    stretch = {
      stretchYears,
      annualHit,
      schedule,
      savingsYear1: deadMoney[0] - annualHit,
    };
  }

  // Two-way player check
  const isTwoWay = !!player.isTwoWay;
  if (isTwoWay) {
    // Two-way contracts: after Jan 10, guaranteed at ~$318K (half base comp)
    const twoWayGuarantee = 318218;
    return {
      player: player.name,
      isTwoWay: true,
      deadMoney: [twoWayGuarantee, 0, 0, 0],
      totalDead: twoWayGuarantee,
      deadYears: 1,
      details: [{ year: '2025-26', amount: twoWayGuarantee, status: 'Two-Way Guarantee', dead: true }],
      canWaiveClean: false,
      stretch: null,
      postMarch1: seasonPhase === 'postDeadline' || seasonPhase === 'playoffs',
    };
  }

  return {
    player: player.name,
    isTwoWay: false,
    currentSalary: player.salary2526,
    deadMoney,
    totalDead,
    deadYears,
    details,
    canWaiveClean,
    stretch,
    postMarch1: false, // Will be set by caller based on phase
    optionMap,
  };
}

/**
 * Execute waive — removes player from team, adds dead money, returns updated data
 * @returns {{ newSalaryData, waiveDetails, freeAgent }}
 */
export function executeWaive(salaryData, teamAbbr, playerName, useStretch = false) {
  const team = salaryData[teamAbbr];
  if (!team) return null;

  const playerIdx = team.players.findIndex(p => p.name === playerName);
  if (playerIdx === -1) return null;

  const player = team.players[playerIdx];

  // Dead cap entries are not waivable — they're cap hits, not players
  if (player.isDead) return null;

  const analysis = analyzeWaive(player);

  // Deep clone
  const newData = JSON.parse(JSON.stringify(salaryData));
  const newTeam = newData[teamAbbr];

  // Remove player from roster
  newTeam.players.splice(playerIdx, 1);

  // Add dead money entry if there's guaranteed money owed
  if (analysis.totalDead > 0) {
    const yearLabels = ['salary2526', 'salary2627', 'salary2728', 'salary2829'];

    const deadEntry = {
      name: `${playerName} (dead cap)`,
      nbaComId: 0,
      salary2526: 0, salary2627: 0, salary2728: 0, salary2829: 0,
      option: '',
      isDead: true,
      waiveDate: new Date().toISOString(),
    };

    if (useStretch && analysis.stretch) {
      // Stretch: spread evenly across stretch years
      const s = analysis.stretch;
      for (let i = 0; i < Math.min(s.stretchYears, 4); i++) {
        deadEntry[yearLabels[i]] = s.schedule[i] || 0;
      }
    } else {
      // Standard: dead money in original years
      for (let i = 0; i < 4; i++) {
        deadEntry[yearLabels[i]] = analysis.deadMoney[i] || 0;
      }
    }

    newTeam.players.push(deadEntry);
  }

  // Recalculate payroll
  newTeam.payroll = newTeam.players.reduce((s, p) => s + (p.salary2526 || 0), 0);

  // Create free agent entry
  const pos = PLAYER_POSITIONS[playerName] || player.position || 'SF';
  const ovr = getPlayerRating(playerName) || 70;
  const freeAgent = {
    name: playerName,
    position: pos,
    age: null, // Would come from API
    lastTeam: teamAbbr,
    type: 'UFA',
    reason: useStretch ? 'waived-stretched' : 'waived',
    ovr,
    priorSalary: player.salary2526 || 0,
    addedAt: Date.now(),
  };

  return {
    newSalaryData: newData,
    waiveDetails: analysis,
    freeAgent,
  };
}

// ============================================================================
// POOL MANAGEMENT
// ============================================================================

/**
 * Cross-reference: remove any player from the pool who is currently
 * on a team's roster in salaryData. This catches:
 *   - Stale initial data (player signed since list was compiled)
 *   - Players user traded for (now on a roster)
 *   - Any mismatch between pool and actual rosters
 */
export function filterRosteredPlayers(pool, salaryData) {
  // Build a Set of all rostered player names
  const rostered = new Set();
  for (const [, team] of Object.entries(salaryData)) {
    if (!team?.players) continue;
    for (const p of team.players) {
      if (p.isDead) continue; // Dead cap entries don't count
      rostered.add(p.name);
    }
  }
  return pool.filter(fa => !rostered.has(fa.name));
}

/**
 * Initialize pool (merges saved pool with defaults, filters against rosters)
 */
export function initPool(savedPool, salaryData) {
  let pool;
  if (savedPool && savedPool.length > 0) {
    pool = savedPool;
  } else {
    // Enrich initial pool with OVR ratings
    pool = INITIAL_FREE_AGENTS.map(fa => ({
      ...fa,
      ovr: getPlayerRating(fa.name) || estimateOVR(fa),
      priorSalary: estimateAskingPrice(fa),
      addedAt: 0,
    }));
  }
  // Always cross-reference against current rosters
  if (salaryData) {
    pool = filterRosteredPlayers(pool, salaryData);
  }
  return pool;
}

/**
 * Add a player to the free agent pool
 */
export function addToPool(pool, freeAgent) {
  // Don't duplicate
  if (pool.some(p => p.name === freeAgent.name)) return pool;
  return [...pool, freeAgent];
}

/**
 * Remove a player from the pool (when signed)
 */
export function removeFromPool(pool, playerName) {
  return pool.filter(p => p.name !== playerName);
}

/**
 * Add all expiring contracts to pool (end of season transition)
 */
export function addExpiringToPool(pool, salaryData) {
  let newPool = [...pool];
  for (const [teamAbbr, team] of Object.entries(salaryData)) {
    if (!team?.players) continue;
    for (const p of team.players) {
      if (p.isDead) continue;
      // Expiring: has current year salary but no next year
      if (p.salary2526 > 0 && !p.salary2627) {
        const pos = PLAYER_POSITIONS[p.name] || 'SF';
        const ovr = getPlayerRating(p.name) || 70;
        if (!newPool.some(fa => fa.name === p.name)) {
          newPool.push({
            name: p.name,
            position: pos,
            age: null,
            lastTeam: teamAbbr,
            type: 'UFA',
            reason: 'expired',
            ovr,
            priorSalary: p.salary2526,
            addedAt: Date.now(),
          });
        }
      }
    }
  }
  return newPool;
}

// ============================================================================
// HELPERS
// ============================================================================

function estimateOVR(fa) {
  // Rough OVR for known but unrated free agents
  if (fa.name === 'Bradley Beal') return 78;
  if (fa.name === 'Damian Lillard') return 80;
  if (fa.name === 'Ben Simmons') return 72;
  if (fa.name === 'Malik Beasley') return 73;
  if (fa.name === 'Tre Mann') return 71;
  if (fa.name === 'Chris Boucher') return 70;
  if (fa.name === 'Mo Bamba') return 69;
  return 65 + Math.floor(Math.random() * 8);
}

function estimateAskingPrice(fa) {
  const ovr = fa.ovr || estimateOVR(fa);
  if (ovr >= 85) return 30000000;
  if (ovr >= 80) return 15000000;
  if (ovr >= 75) return 8000000;
  if (ovr >= 70) return 3000000;
  return 2000000; // Vet min range
}

export default {
  INITIAL_FREE_AGENTS,
  analyzeWaive,
  executeWaive,
  initPool,
  addToPool,
  removeFromPool,
  addExpiringToPool,
};
